import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';

import config from '../../config';

import AdminImportPage from '../shared/adminImportPage.component';
import { adminPageNames, adminPageTitles } from '../shared/adminPageNames';

import AdminColumnRenderer from './companyCodesAdminColumnRenderer.component';
import AddEditModal from './addCompanyCodeModal.component';
import downloadXlsxFile from './downloadCompanyCodesXlsx';
import additionalHamburgerMenuItems from './additionalHamburgerMenuItems.component';

import {
  sharedActions,
} from './store/actions';

import { withPermissions, permissions } from '../../shared/authorization';
import columnDefinitions, { importCompanyCodeColumnDefs } from '../../shared/columnDefinitions/companyCodes';
import { fromSearchString } from '../../shared/urlUtils';
import { mergeColumnDefinitionsField } from '../../utils/columnDefinitionUtils';
import { sortBySeverity } from '../../shared/sortBySeverity';

const columnDefinitionsWithDefaultSorting = mergeColumnDefinitionsField(['severity'], {
  sort: 'asc',
  comparator: (a, b) => sortBySeverity({ severity: a }, { severity: b }),
})(columnDefinitions);

const CompanyCodesPage = ({
  canModifyInSelectedPeriod,
}) => {
  const { search } = useLocation();
  const generateTemplateFileName = useCallback(
    ({ periodName }) => `TLS_Company_Codes_${periodName}`,
    []);
  const initialFilters = useMemo(() => ({
    companyCode: fromSearchString(search, true)?.companyCode,
    legalEntity: fromSearchString(search, true)?.legalEntity,
  }), [search]);

  return (
    <>
      <AdminImportPage
        pageName={adminPageNames.COMPANY_CODES}
        canModify={canModifyInSelectedPeriod}
        AddEditEntityModal={AddEditModal}
        adminColumnRenderer={AdminColumnRenderer}
        addEntityMessage="Add Company Code"
        importColumnDefs={importCompanyCodeColumnDefs}
        columnDefs={columnDefinitionsWithDefaultSorting}
        actions={sharedActions}
        exportToExcel={downloadXlsxFile}
        generateTemplateFileName={generateTemplateFileName}
        templatePath={config.templates.COMPANY_CODES}
        comparatorConfig={{
          idField: 'companyCode',
        }}
        pageTitle={adminPageTitles.COMPANY_CODES}
        additionalHamburgerMenuItems={additionalHamburgerMenuItems}
        initialFilters={initialFilters}
      />
      <ReactTooltip place="right" effect="float" />
    </>
  );
};

CompanyCodesPage.propTypes = {
  canModifyInSelectedPeriod: PropTypes.bool.isRequired,
};

export default withPermissions(permissions.COMPANY_CODES)(CompanyCodesPage);
